(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@normy/query-core"), require("@normy/core"));
	else if(typeof define === 'function' && define.amd)
		define(["@normy/query-core", "@normy/core"], factory);
	else if(typeof exports === 'object')
		exports["NormyVueQuery"] = factory(require("@normy/query-core"), require("@normy/core"));
	else
		root["NormyVueQuery"] = factory(root["NormyQueryCore"], root["Normy"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__124__, __WEBPACK_EXTERNAL_MODULE__700__) => {
return 